import React from 'react';

// Små stilar som båda Shelly-flikarna använder.

/** Centrerad grå text för "Hämtar…" och tomma listor. */
export const centerNote = (color = '#6b7280'): React.CSSProperties => ({
    textAlign: 'center', padding: 32, color,
});
